import React, { useEffect, useState } from 'react';
import '../../../Assets/Css/EmpAttendanceByHour.scss';
import Absent from "../../../Assets/Images/Attendance/absent.svg";
import Holiday from "../../../Assets/Images/Attendance/Holiday.svg";
import RightArrow from "../../../Assets/Images/Attendance/Right Arrow.svg";
import Leave from "../../../Assets/Images/Attendance/leave.svg";
import Halfday from "../../../Assets/Images/Attendance/half-day.svg";
import UserAvatar from 'react-user-avatar';
import moment from 'moment';

function EmpTaskByHour(props) {
    const [daysInMonth, setDaysInMonth] = useState([]);
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    const [selectedMonth, setSelectedMonth] = useState(month);
    const [selectedYear, setSelectedYear] = useState(year);
    const [usersAllData, setUserAllData] = useState([]);

    const calculateDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const selectedEmp = props?.selectedUser
        ? props?.data?.users?.filter((user) => user?.id === props?.selectedUser?.id) || []
        : props?.data?.user?.role?.name?.includes('hr')
            ? props?.data?.users || []
            : props?.data?.users?.filter((user) => user?.id === props?.data?.user?.id) || [];

    useEffect(() => {
        const allUserData = selectedEmp?.map((emp) => {
            const attendanceData = props?.data?.task?.filter((att) =>
                att?.taskUserMap?.some((item) => item.user_id === emp?.id)
            ) || [];

            const leaveData = props?.data?.leave?.filter((leave) => leave?.employee_id === emp?.id) || [];

            const leaveMap = {};
            leaveData.forEach(leave => {
                if (leave.status === 'Approved') {
                    const startDate = moment(leave?.start_date).startOf('day');
                    const endDate = moment(leave?.end_date).startOf('day');

                    let currentDate = startDate.clone();
                    while (currentDate.isSameOrBefore(endDate, 'day')) {
                        const dateKey = currentDate.format('YYYY-MM-DD');
                        if (leaveMap[dateKey]) {
                            leaveMap[dateKey] = {
                                ...leaveMap[dateKey],
                                firstHalf: leaveMap[dateKey].firstHalf || leave.firstHalf,
                                secondHalf: leaveMap[dateKey].secondHalf || leave.secondHalf,
                                reason: leaveMap[dateKey].reason + (leave.reason !== leaveMap[dateKey].reason ? ` & ${leave.reason}` : ''),
                                casual: (parseFloat(leaveMap[dateKey].casual || 0) + parseFloat(leave.casual || 0)).toString(),
                                unpaid: (parseFloat(leaveMap[dateKey].unpaid || 0) + parseFloat(leave.unpaid || 0)).toString()
                            };
                        } else {
                            leaveMap[dateKey] = { ...leave };
                        }
                        currentDate.add(1, 'day');
                    }
                }
            });

            const dailyhours = attendanceData?.flatMap((att) =>
                att?.taskTimerMap?.map((timer) => {
                    const startTime = new Date(timer?.start_time);
                    const endTime = timer?.stop_time ? new Date(timer?.stop_time) : new Date();
                    const durationInMinutes = (endTime - startTime) / (1000 * 60);
                    return {
                        date: startTime.toLocaleDateString('en-CA'),
                        mins: durationInMinutes,
                    };
                }) || []
            ) || [];

            const groupedByDate = {};
            dailyhours.forEach(({ date, mins }) => {
                if (!groupedByDate[date]) {
                    groupedByDate[date] = 0;
                }
                groupedByDate[date] += mins;
            });

            const days = calculateDaysInMonth(selectedMonth, selectedYear);
            const totalTimePerDate = Array.from({ length: days }, (_, index) => {
                const dateObj = new Date(selectedYear, selectedMonth - 1, index + 1);
                const date = dateObj.toLocaleDateString('en-CA');
                const dayName = moment(date).format('ddd');

                const totalMins = groupedByDate[date] || 0;
                const hours = Math.floor(totalMins / 60);
                const minutes = Math.round(totalMins % 60);
                const formatted = `${hours.toString()}:${minutes.toString().padStart(2, '0')}`;

                const leave = leaveMap[date];
                let status = '';

                if (leave?.firstHalf && leave?.secondHalf) {
                    status = 'ol';
                } else if (leave?.firstHalf || leave?.secondHalf) {
                    status = 'hd';
                } else if (dayName === 'Sun') {
                    status = 'Sun';
                } else if (!groupedByDate[date]) {
                    const today = moment().startOf('day');
                    const currentDate = moment(date);
                    if (currentDate.isBefore(today)) {
                        status = 'a';
                    } else {
                        status = '';
                    }
                }


                return {
                    date,
                    totalMinutes: totalMins,
                    formattedTime: totalMins ? formatted : '',
                    status,
                    hours
                };
            });

            return {
                id: emp?.id,
                name: emp?.name,
                avatar: emp?.avatar,
                role: emp?.role?.name || '',
                totalTimePerDate,
            };
        }) || [];

        setUserAllData(allUserData);
    }, [selectedEmp, props, selectedMonth, selectedYear]);

    useEffect(() => {
        const days = calculateDaysInMonth(selectedMonth, selectedYear);
        const daysArray = Array.from({ length: days }, (_, index) => {
            const date = new Date(selectedYear, selectedMonth - 1, index + 1);
            return {
                day: index + 1,
                dateString: date.toLocaleDateString('en-CA'),
                dayName: date.toLocaleDateString('en-US', { weekday: 'short' }),
            };
        });
        setDaysInMonth(daysArray);
    }, [selectedYear, selectedMonth]);

    useEffect(() => {
        if (props?.selectFilters?.Month?.value) {
            setSelectedMonth(new Date(`${props.selectFilters.Month.value} 1,${selectedYear}`).getMonth() + 1);
        }
        if (props?.selectFilters?.Year?.value) {
            setSelectedYear(parseInt(props.selectFilters.Year.value));
        }
    }, [props.selectFilters]);

    return (
        <div className="attendance-table">
            <div className="suggestion">
                <h6 className='m-0 me-2'>Note :</h6>
                <div className='suggestion_comp'><img src={Holiday} className='svg' alt="Holiday" /><img src={RightArrow} className='svgarrow' alt="Arrow" />Holiday</div>
                <div className='suggestion_comp'><img src={Halfday} className='svg' alt="Half Day" /><img src={RightArrow} className='svgarrow' alt="Arrow" />Half Day</div>
                <div className='suggestion_comp'><img src={Absent} className='svg' alt="Absent" /><img src={RightArrow} className='svgarrow' alt="Arrow" />Absent</div>
                <div className='suggestion_comp'><img src={Leave} className='svg' alt="Leave" /><img src={RightArrow} className='svgarrow' alt="Arrow" />On leave</div>
            </div>

            <div className='table_cont'>
                <table>
                    <thead>
                        <tr>
                            <th className='firsttablehead'>Employee</th>
                            {daysInMonth.map((item, idx) => (
                                <th key={idx}>{item.day}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usersAllData?.map((employee, index) => {
                            const timeMap = Object.fromEntries(
                                employee.totalTimePerDate.map(item => [item.date, item])
                            );

                            const totalMinutes = employee.totalTimePerDate.reduce((acc, curr) => acc + curr.totalMinutes, 0);
                            const totalHours = Math.floor(totalMinutes / 60);
                            const totalMins = Math.round(totalMinutes % 60);
                            const totalFormatted = `${totalHours.toString().padStart(2, '0')}:${totalMins.toString().padStart(2, '0')}`;

                            return (
                                <tr key={index}>
                                    <td className="employee-info">
                                        {employee?.avatar ? (
                                            <img src={employee.avatar} alt={employee.name} />
                                        ) : (
                                            employee?.name && <UserAvatar name={employee?.name || ""} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                        )}
                                        <div className='employee-info-details'>
                                            <span>{employee.name}</span>
                                            <span className="role">{employee.role}</span>
                                        </div>
                                    </td>
                                    {daysInMonth.map((day, dayIdx) => {
                                        const item = timeMap[day.dateString];
                                        return (
                                            <td key={dayIdx}>
                                                {(() => {
                                                    if (!item) return '-';
                                                    switch (item.status) {
                                                        case "Sun":
                                                            return (
                                                                <div className="sh-img">
                                                                    <img src={Holiday} className='svg_table' />
                                                                    <div className="tooltip">Sunday</div>
                                                                </div>
                                                            );
                                                        case "ol": return <img src={Leave} className='svg_table' />;
                                                        case "hd": return <img src={Halfday} className='svg_table' />;
                                                        case "a": return <img src={Absent} className='svg_table' />;
                                                        default: return item.formattedTime || <span style={{ fontWeight: 'normal' }}>-</span>;
                                                    }
                                                })()}
                                            </td>
                                        );
                                    })}
                                    <td><strong>{totalFormatted}</strong></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default EmpTaskByHour;